import React from 'react'
import PropTypes from 'prop-types'
import PaymentStatus from '../../PaymentStatus'

const StatusCell = ({getValue}) => {
  const status = getValue()

  return <PaymentStatus status={status} />
}

StatusCell.propTypes = {
  getValue: PropTypes.func.isRequired,
}

export default StatusCell
